import React from 'react';
import { useProfilePointsModel } from './model';
import { ProfilePointsView } from './view';

export const ProfilePointsWidget: React.FC = () => {
  const { state, reload } = useProfilePointsModel();

  return <ProfilePointsView state={state} onRefresh={reload} />;
};
